// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_header_subtitle-module__container--r5mvG{width:100%;margin-bottom:4px;margin-top:4px;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.decision_header_subtitle-module__validated--2rmK-{display:inline;font-weight:400;border-bottom:1px dotted transparent;cursor:pointer;border-color:#36b;color:#36b}.decision_header_subtitle-module__notValidated--3veNq{display:inline;font-weight:400;border-bottom:1px dotted transparent;cursor:pointer;border-color:#c42e54;color:#c42e54}.decision_header_subtitle-module__separator--1AY88{margin:0px 4px}\n", ""]);
// Exports
exports.locals = {
	"container": "decision_header_subtitle-module__container--r5mvG",
	"validated": "decision_header_subtitle-module__validated--2rmK-",
	"notValidated": "decision_header_subtitle-module__notValidated--3veNq",
	"separator": "decision_header_subtitle-module__separator--1AY88"
};
module.exports = exports;
